import { FormattedMessage } from 'react-intl';

import IconRight from '@/assets/icons/icon-right.svg';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

interface HiringGoalHiresProps {
  actual: number | null;
  expected: number | null;
  onViewPastGoals: () => void;
}

function getProgress(expected: number | null, actual: number | null) {
  if (!actual || !expected) return 0;
  return (actual / expected) * 100;
}

export function HiringGoalHires({
  actual,
  expected,
  onViewPastGoals,
}: HiringGoalHiresProps) {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <Typography variant="caption">
        <FormattedMessage
          defaultMessage="Hires"
          description="Caption above hire count and progress for the hiring goal"
        />
      </Typography>
      <div className="flex w-full items-center justify-between gap-2">
        <Typography variant="large2" className="whitespace-nowrap">
          <span>{actual ?? '-'}</span>
          <span className="text-fx-neutral-600"> / {expected ?? '-'}</span>
        </Typography>
        <Button
          variant="ghost"
          className="text-fx-neutral-900 h-6 shrink-0 gap-1 p-0 font-medium hover:bg-white"
          onClick={onViewPastGoals}
        >
          <FormattedMessage
            defaultMessage="View past goals"
            description="Opens the hiring goals modal to browse past goals for this opening"
          />
          <img src={IconRight} alt="" aria-hidden="true" />
        </Button>
      </div>
      <Progress
        value={getProgress(expected, actual)}
        className="bg-fx-primary"
        rootClassName="h-1"
      />
    </div>
  );
}

HiringGoalHires.Skeleton = function HiringGoalHiresSkeleton() {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <Typography variant="caption">
        <FormattedMessage
          defaultMessage="Hires"
          description="Caption above hire count and progress for the hiring goal"
        />
      </Typography>
      <div className="flex w-full items-center justify-between gap-2">
        <Skeleton className="h-6 w-16" />
        <Skeleton className="h-5 w-28" />
      </div>
      <Skeleton className="h-1 w-full" />
    </div>
  );
};
